/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserModerationsModeratorControllerFindManyQueryResponse,
  UserModerationsModeratorControllerFindManyQueryParams,
  UserModerationsModeratorControllerFindMany401,
} from '../../types/UserModerationsModeratorControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { userModerationsModeratorFindMany } from '../../methods/userModerationsModeratorFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const userModerationsModeratorFindManyQueryKey = (
  params?: UserModerationsModeratorControllerFindManyQueryParams,
) => [{ url: '/api/moderator/user-moderations' }, ...(params ? [params] : [])] as const;

export type UserModerationsModeratorFindManyQueryKey = ReturnType<typeof userModerationsModeratorFindManyQueryKey>;

export function userModerationsModeratorFindManyQueryOptions(
  params?: UserModerationsModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = userModerationsModeratorFindManyQueryKey(params);
  return queryOptions<
    UserModerationsModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerFindMany401>,
    UserModerationsModeratorControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return userModerationsModeratorFindMany(params, config);
    },
  });
}

/**
 * {@link /api/moderator/user-moderations}
 */
export function useUserModerationsModeratorFindMany<
  TData = UserModerationsModeratorControllerFindManyQueryResponse,
  TQueryData = UserModerationsModeratorControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = UserModerationsModeratorFindManyQueryKey,
>(
  params?: UserModerationsModeratorControllerFindManyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        UserModerationsModeratorControllerFindManyQueryResponse,
        ResponseErrorConfig<UserModerationsModeratorControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userModerationsModeratorFindManyQueryKey(params);

  const query = useQuery(
    {
      ...userModerationsModeratorFindManyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<UserModerationsModeratorControllerFindMany401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
